"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _userflow = _interopRequireDefault(require("../../../../styles/userflow"));

var InputHeader = function InputHeader(props) {
  var className = props.className,
      text = props.text,
      prependIcon = props.prependIcon,
      _props$isMobile = props.isMobile,
      isMobile = _props$isMobile === void 0 ? false : _props$isMobile;
  var hasContent = Boolean(text) || Boolean(prependIcon);

  if (!hasContent) {
    return null;
  }

  return /*#__PURE__*/_react["default"].createElement(StyledInputHeader, {
    className: className
  }, text ? /*#__PURE__*/_react["default"].createElement(StyledHeaderWrapper, null, /*#__PURE__*/_react["default"].createElement(StyledHeader, null, text)) : null, prependIcon ? /*#__PURE__*/_react["default"].createElement(StyledPrependIconContainer, {
    isMobile: isMobile,
    isEmpty: false
  }, prependIcon) : null);
};

var ICON_HEIGHT = 14;
var ICON_WIDTH = 14;
var ICON_PADDING = 10;

var StyledInputHeader = _styledComponents["default"].label.withConfig({
  displayName: "InputHeader__StyledInputHeader",
  componentId: "sc-12gtvb4-0"
})(["margin-bottom:4px;display:flex;position:relative;"]);

var StyledPrependIconContainer = _styledComponents["default"].div.withConfig({
  displayName: "InputHeader__StyledPrependIconContainer",
  componentId: "sc-12gtvb4-1"
})(["margin-top:", "px;margin-left:", "px;svg:first-child{position:relative;height:", "px;width:", "px;stroke-width:1;", ";}"], function (_ref) {
  var isMobile = _ref.isMobile;
  return isMobile ? 3 : 5;
}, ICON_PADDING, ICON_HEIGHT, ICON_WIDTH, function (_ref2) {
  var isEmpty = _ref2.isEmpty;
  return "\n      stroke: ".concat(isEmpty ? _userflow["default"].colors.greyLight : _userflow["default"].colors.blackLight, "\n    ");
});

var StyledHeader = _styledComponents["default"].div.withConfig({
  displayName: "InputHeader__StyledHeader",
  componentId: "sc-12gtvb4-2"
})(["font-size:14px;line-height:16px;align-items:center;color:", ";"], _userflow["default"].colors.blackLight);

var StyledHeaderWrapper = _styledComponents["default"].div.withConfig({
  displayName: "InputHeader__StyledHeaderWrapper",
  componentId: "sc-12gtvb4-3"
})(["margin:4px 0;display:flex;div + div{margin-left:4px;}"]);

var _default = InputHeader;
exports["default"] = _default;